import type { I18n } from '@/shared/i18n'
import type { SupportKind, SupportSeverity } from '@/shared/types/domain'

/** En el orden en que se atienden. Es también el orden del servidor. */
export const SEVERITIES: readonly SupportSeverity[] = ['urgent', 'high', 'medium', 'low']
export const KINDS: readonly SupportKind[] = ['bug', 'improvement', 'feature']

/** El plazo que se puede elegir para un no urgente: de 1 a 10 días. */
export const DUE_DAYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const

/**
 * El semáforo sale de los tokens que ya significan urgencia en toda la app:
 * rojo de "vencida", naranja de "vence hoy", ámbar de "por vencer" y el verde
 * apagado de lo hecho. Así urgente se lee igual que una tarea vencida.
 */
export const SEVERITY_VAR: Record<SupportSeverity, string> = {
  urgent: '--overdue',
  high: '--due-today',
  medium: '--due-soon',
  low: '--done',
}

/** Color + ícono + texto, nunca sólo color. */
export const SEVERITY_GLYPH: Record<SupportSeverity, string> = {
  urgent: '!!',
  high: '!',
  medium: '•',
  low: '↓',
}

export function severityLabel(t: I18n['t'], severity: SupportSeverity): string {
  switch (severity) {
    case 'urgent':
      return t('support.severity.urgent')
    case 'high':
      return t('support.severity.high')
    case 'medium':
      return t('support.severity.medium')
    case 'low':
      return t('support.severity.low')
  }
}

export function kindLabel(t: I18n['t'], kind: SupportKind): string {
  switch (kind) {
    case 'bug':
      return t('support.kind.bug')
    case 'improvement':
      return t('support.kind.improvement')
    case 'feature':
      return t('support.kind.feature')
  }
}
